import { Publication } from "../models/workflow.model";
import ServiceBase from "./base.service";

export class DocumentsService extends ServiceBase {
  download = async (documentId: number): Promise<void> =>
    this._download(`documents/download/${documentId}`);
  downloadTemplate = async (templateCode: string): Promise<void> =>
    this._download(`documents/download/template/${templateCode}`);
    documentIDByPublication = async (ticketNumber?: string): Promise<Publication> =>
    this.get(`documents/GetDocumentId/${ticketNumber}`);
}

const documentsService = new DocumentsService();

export default documentsService;
